import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { GlobalsStore } from '../../../stores/globals.state';
import { RouterLink } from '@angular/router';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';
import { DataLayerType } from '../../../models/data-layer-type';
import { TableRowAction } from '../table-row-indicator/table-row-indicator.component';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[app-table-row-data-layer-type]',
  standalone: true,
  imports: [ButtonModule, RouterLink, SvgIconComponent, TooltipModule],
  templateUrl: './table-row-data-layer-type.component.html',
  styleUrl: './table-row-data-layer-type.component.scss',
})
export class TableRowDataLayerTypeComponent {
  readonly globalStore = inject(GlobalsStore);
  @Input() item!: DataLayerType;
  @Input() external = false;
  @Input() actions: TableRowAction[] = [];
  @Output() closeEvent = new EventEmitter<void>();
  @Output() generateViewEvent = new EventEmitter<DataLayerType>();

  /**
   * Generates and emits a view event for the given data layer type, then closes the parent component.
   *
   * @param {DataLayerType} type - The data layer type for which the view event should be generated.
   * @return {void} This method does not return a value.
   */
  generateView(type: DataLayerType): void {
    this.generateViewEvent.emit(type);
    this.closeParent();
  }

  /**
   * Selects a specific data layer type, updates the global store with the selected type,
   * and performs any necessary actions to close the parent component or interface.
   *
   * @param {DataLayerType} type - The data layer type to be selected.
   * @return {void} No value is returned.
   */
  select(type: DataLayerType): void {
    this.globalStore.setSelectedType(type);
    this.closeParent();
  }

  /**
   * Closes the parent component or view by emitting the close event.
   *
   * @return {void} No return value.
   */
  addPoi(poiId: string): void {
    this.globalStore.triggerAtlasEvent('addPoiToMaps', {
      poiLayerTypeId: poiId,
    });
    this.closeParent();
  }

  /**
   * Closes the parent component or view by emitting the close event.
   *
   * @return {void} No return value.
   */
  closeParent(): void {
    this.closeEvent.emit();
  }
}
